<template>
  <h1 class="covid-search-title">
    {{ title }}
    <template v-if="secondTitle">
      <span class="covid-search-title"> {{ secondTitle }} </span>
    </template>
  </h1>
  <div v-if="isLessThanLargeDesktop" class="covid-search-form-toptext">
    <p>
      {{ text }}
    </p>
  </div>
  <div v-if="isLessThanLargeDesktop">
    <div v-html="$sanitize(sideBarContent)" class="covid-search-side"/>
  </div>
  <form class="covid-search-form">
    <div class="covid-search-form-inner">
      <div v-if="isLargeDesktop" class="covid-search-form-toptext">
        <p>
          {{ text }}
        </p>
      </div>
      <fieldset>
        <legend class="sr-only">Sélectionnez le département et la ville</legend>
        <div class="covid-search-form-fields">
          <div class="select">
            <select v-model="currentUrl"
                    @change="$emit('onRegionChange',currentUrl)"
                    aria-label="Sélectionnez un département - rechargement de page"
                    title="Sélectionnez un département - rechargement de page">
              <option value="0">- Sélectionnez votre département -</option>
              <option
                v-for="region in regions"
                :key="region.getValue()"
                :value="region.getValue()"
                :selected="currentUrl == region.getValue()"
              >
                {{ region.getLabel() }}
              </option>
            </select>
          </div>
        </div>
        <div v-if="cities.length" class="covid-search-form-fields">
          <div class="select">
            <select
              v-model="citySelected"
              @change="$emit('onCityChange', citySelected)"
              aria-label="Sélectionnez une ville"
              title="Sélectionnez une ville"
            >
              <option value="0">- Sélectionnez une ville -</option>
              <option
                v-for="city in cities"
                :key="city.getValue()"
                :value="city.getValue()"
              >
                {{ city.getLabel() }}
              </option>
            </select>
          </div>
        </div>
      </fieldset>
      <div v-if="hasFilters" class="covid-search-filters">
        <h2>Filtrer :</h2>
        <fieldset
          class="form-group"
        >
          <legend class="sr-only">Type de test</legend>
          <div
            v-for="testType in testTypes"
            :key="testType.value"
            class="checkbox-item"
          >
            <input
              :id="`checkbox-type-test-${testType.value}`"
              type="checkbox"
              :checked="testType.isChecked"
              @input="$emit('onFilter', testType.value)"
              name="type-test"
              :value="testType.value"
              data-tid="214143"
            /><label :for="`checkbox-type-test-${testType.value}`">{{
              testType.label
            }}</label>
          </div>
        </fieldset>
        <div class="select">
          <select
            id="type-lieu-select"
            aria-label="Sélectionner un type de lieu"
            title="Sélectionner un type de lieu"
            @change="
              $emit('onScreeningCenterChange', screeningCenterType)
            "
            v-model="screeningCenterType"
          >
            <option value="0">Type de lieu</option>
            <option
              v-for="place in places"
              :key="place.getValue()"
              :value="place.getValue()"
            >
              {{ place.getLabel() }}
            </option>
          </select>
        </div>
        <div class="form-group" style="display: none">
          <div class="select">
            <select id="crenaux-select" v-model="typeSelected"
              @change="$emit('onTypeChange',typeSelected)"
              aria-label="Sélectionner un type de centre de dépistage"
              title="Sélectionner un type de centre de dépistage">
              <option value="0">Type de centre de dépistage</option>
              <option
                v-for="screeningCenter in screeningCenters"
                :key="screeningCenter.value"
                :value="screeningCenter.value"
                data-tid="213781"
              >
                {{ screeningCenter.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import { inject } from 'vue';
import { ContentService } from '@/services';

export default {
  emits: ['onRegionChange', 'onFilter', 'onTypeChange', 'onCityChange', 'onScreeningCenterChange'],
  props: {
    regions: {
      type: Array,
      default: () => [],
    },
    cities: {
      type: Array,
      default: () => [],
    },
    places: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    secondTitle: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    hasFilters: {
      type: Boolean,
      default: false,
    },
    testTypes: {
      type: Array,
      default: () => [],
    },
    screeningCenters: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const isLessThanLargeDesktop = inject('isLessThanLargeDesktop');
    const isLargeDesktop = inject('isLargeDesktop');
    const content = ContentService.getSearchCentersPageContents();
    const sideBarContent = content?.field_right_column_text
      && content?.field_right_column_text[0]?.value;
    const currentUrl = window.location.pathname === '/cf/centres-depistage-covid.html' ? 0 : window.location.pathname;
    return {
      sideBarContent,
      citySelected: 0,
      typeSelected: 0,
      regionSelected: 0,
      screeningCenterType: 0,
      isLessThanLargeDesktop,
      isLargeDesktop,
      currentUrl,
    };
  },
};
</script>
